import React from 'react';

interface SlotLockProgressBarProps {
  elapsed_seconds: number;
  remaining_seconds: number;
  percentage: number;
  status: 'green' | 'yellow' | 'red';
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const SlotLockProgressBar: React.FC<SlotLockProgressBarProps> = ({
  percentage,
  status,
  remaining_seconds,
  showLabel = true,
  size = 'md',
}) => {
  const statusConfig = {
    green: {
      bg: 'bg-green-100',
      text: 'text-green-700',
      bar: 'bg-green-500',
      label: 'Possible booking',
    },
    yellow: {
      bg: 'bg-yellow-100',
      text: 'text-yellow-700',
      bar: 'bg-yellow-500',
      label: '50/50 chance',
    },
    red: {
      bg: 'bg-red-100',
      text: 'text-red-700',
      bar: 'bg-red-500',
      label: 'Probably won\'t complete',
    },
  };

  const config = statusConfig[status];
  
  const sizeClasses = {
    sm: 'h-1',
    md: 'h-2',
    lg: 'h-3',
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="space-y-1">
      {showLabel && (
        <div className="flex justify-between items-center">
          <span className={`text-xs font-medium ${config.text}`}>
            {config.label}
          </span>
          <span className="text-xs text-gray-500">
            {formatTime(remaining_seconds)} left
          </span>
        </div>
      )}
      <div className={`w-full rounded-full ${config.bg} ${sizeClasses[size]}`}>
        <div
          className={`${config.bar} ${sizeClasses[size]} rounded-full transition-all duration-500`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};
